<template>
  <Popup
      v-if="showPopup"
      @close="$emit('close')"
      :close-with-esc="true"
      width="500px"
      modal-header-class="modal-header-border"
      body-padding="0 32px 32px"
      header-padding="0 32px 0"
  >
    <template v-slot:title>
      Cancel Subscription
    </template>
    <template v-slot:body>
      <p>Cancel subscription for <strong>{{ currentProductName }}</strong></p>

      <p><b>Cancellation Reason:</b></p>
      <ul class="cancellation-reason">
        <li>
          <RadioElement v-model="cancellationReason" value="1" name="cancellationReason"
                        id="priceIsToHigh"
                        label="Price is too high"/>
        </li>
        <li>
          <RadioElement v-model="cancellationReason" value="2" name="cancellationReason"
                        id="noLongerNeedThisProduct"
                        label="No longer needed"/>
        </li>
        <li>
          <RadioElement v-model="cancellationReason" value="3" name="cancellationReason"
                        id="notSatisfiedWithTheProduct"
                        label="Not satisfied with the product"/>
        </li>
        <li>
          <RadioElement v-model="cancellationReason" value="4" name="cancellationReason"
                        id="switchedToAnotherProduct"
                        label="Switched to another product"/>
        </li>
        <li>
          <RadioElement v-model="cancellationReason" value="5" name="cancellationReason"
                        id="notPriorityRightNow"
                        label="Not a priority right now"/>
        </li>
        <li>
          <RadioElement v-model="cancellationReason" value="6" name="cancellationReason"
                        id="subscribedByMistake"
                        label="Subscribed by mistake"/>
        </li>
        <li>
          <RadioElement v-model="cancellationReason" value="7" name="cancellationReason"
                        id="switchingToAnotherSubscriptionPlan"
                        label="Switching to another subscription plan"/>
        </li>
        <li>
          <RadioElement v-model="cancellationReason" value="8" name="cancellationReason" id="other"
                        label="Other"/>
        </li>
        <li>
          <InputElement v-if="cancellationReason === '8'"
                        type="text"
                        placeholder="Write your reason"
                        :name="cancellationReasonText"
                        v-model="cancellationReasonText"
          />
        </li>
      </ul>
    </template>
    <template v-slot:buttons>
      <ButtonElement @click="cancelSubscription()" class="btn--ms btn--danger">Cancel Subscription
      </ButtonElement>
    </template>
  </Popup>
</template>

<script lang="ts">
import {defineComponent} from 'vue';
import {ButtonElement, Popup, RadioElement} from '@shared/components';
import {useProductStore} from "@domains/settings/stores/product.store";
import {ProductNs} from "@shared/types";
import {useWsMemberStore} from "@domains/settings/stores/workspace-member.store";
import {useWorkspaceStore} from "@shared/stores/workspace.store";
import {useUserStore} from "@shared/stores/user.store";
import {useGeneralStore} from "@shared/stores/general.store";
import InputElement from "@shared/components/elements/input/input.element.vue";
import {toast} from '@shared/ms-components'

export default defineComponent({
  name: 'CancelSubscriptionPopup',
  components: {
    InputElement,
    RadioElement,
    Popup,
    ButtonElement
  },
  emits: ['close'],
  props: {
    showPopup: {
      type: Boolean,
      default: false
    },
    currentProductId: {
      type: String,
      required: false
    },
    currentProductName: {
      type: String,
      required: false
    }
  },
  setup() {
    // initialize the store
    const userStore = useUserStore()
    const wsMemberStore = useWsMemberStore()
    const workspaceStore = useWorkspaceStore()
    const productStore = useProductStore()
    const generalStore = useGeneralStore()
    return {workspaceStore, wsMemberStore, productStore, userStore, generalStore}
  },
  mounted() {

  },
  computed: {},
  data() {
    return {
      cancellationReason: '',
      cancellationReasonText: ''
    }
  },
  methods: {
    cancelSubscription() {
      const payload = {
        workspaceId: this.workspaceStore.getSelectedWorkspaceId,
        cancellationReasonId: Number(this.cancellationReason),
        reasonText: this.cancellationReasonText,
        productId: this.currentProductId
      } as ProductNs.CancelSubscriptionRequest;

      this.productStore.cancelSubscription(payload).then(() => {
        
        toast.success('Subscription Cancelled Successfully');
        this.$emit('close')
      })

    }
  }
});

</script>
<style lang="scss" scoped>
.modal-dialog {
  .cancellation-reason {
    margin: var(--space-0);
    padding: var(--space-0);
    list-style-type: none;
    display: flex;
    flex-direction: column;
    gap: var(--space-8);
  }

  .modal-footer {
    padding: var(--space-32);
  }
}

</style>
